<mat-form-field appearance="fill" class="slim-field missing-error">
    <mat-label>Schriftart</mat-label>
    <mat-select [(ngModel)]="font" (ngModelChange)="familyControl.setValue($event.family)">
        <mat-option *ngFor="let googleFont of fonts" [value]="googleFont">
            {{ googleFont.name }}
        </mat-option>
    </mat-select>
</mat-form-field>
